import { useModal } from '@hooks/useModal';
import React, { useMemo } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogHeader,
} from '@PorkyCol/alert-dialog';
import { CreateCustomerForm } from '@modules/customer/forms/create';

export const useCreateCustomerModal = (inputValue: string, setCustomerId: React.Dispatch<React.SetStateAction<string>>) => {
  const { open, handleChange } = useModal();

  const modal = useMemo(
    () => {
      const handlerDataFormSubmit = (values: any) => {
        setCustomerId(values.id)
        handleChange()
      }

      return (
      <AlertDialog className="modal-md" show={open}>
        <AlertDialogHeader className="text-black">Crear Cliente</AlertDialogHeader>
        <AlertDialogBody>
          <CreateCustomerForm callback={handlerDataFormSubmit} inputValue={inputValue} />
        </AlertDialogBody>
      </AlertDialog>

      )

    },
    [open, handleChange, inputValue, setCustomerId]
  );
  return {
    modal,
    actionModal: handleChange,
  };
};
